module.exports = __webpack_public_path__ + "img/bebambi.331b5dea.jpg";